import { useEffect, useMemo, useRef, useState } from "react";
import { useSocket } from "../../context/SocketProvider";
import styles from "./ConnectionComponent.module.css";
import { useLogin } from "../../context/LoginProvider";
import { useConnection } from "../../context/SoulmateProvider";
import { useEmbeddings } from "../../context/EmbeddingsProvider";
import cameraOff from "../../assets/cameraOff.png";
import BackgroundFilter from "./BackgroundFilter";

const configuration = {
  iceServers: [
    { urls: "stun:18.207.238.222:3478" },
    {
      urls: "turn:18.207.238.222:3478",
      username: "admin",
      credential: "admin",
    },
  ],
  iceCandidatePoolSize: 10,
};

let pc;
let localStream;

let remoteVideo;
let localVideo;

export default function ConnectionComponent({
  setroomId,
  setisJoined,

  isJoined,
}) {
  const { embeddings } = useEmbeddings();
  const { socket, audioSocket } = useSocket();
  const remoteVideoDummy = useRef();
  const { setSoulmateUsername, setSoulmateStatus, soulmateStatus } =
    useConnection();
  const [searching, setSearching] = useState(false);
  const [searchDuration, setSearchDuration] = useState(0);
  const searchTimer = useRef(null);

  const [buttonToggle, setButtonToggle] = useState(true);
  const { userData, isLoggedIn, guestData } = useLogin();
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  let isStrictMode = true;

  // New state variables for additional features
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [showBackgroundOptions, setShowBackgroundOptions] = useState(false);
  const [showVoiceOptions, setShowVoiceOptions] = useState(false);
  const [showScreenOptions, setShowScreenOptions] = useState(false);
  const [voiceEffect, setVoiceEffect] = useState("normal"); // normal, deep, high, robot, etc.
  const [isScreenSharing, setIsScreenSharing] = useState(false);
  const [remoteScreenSharing, setRemoteScreenSharing] = useState(false);
  const [isRecordingScreen, setIsRecordingScreen] = useState(false);
  const mediaRecorderRef = useRef(null);
  const recordedChunksRef = useRef([]);
  const filterPanelRef = useRef(null);

  let audioTrack;
  let audioStream;
  localVideo = useRef();
  remoteVideo = useRef();
  const [isRecording, setIsRecording] = useState(false);
  const audioContext = useRef(null);
  const scriptProcessor = useRef(null);
  const audioInput = useRef(null);
  const audioChunks = useRef([]);
  const sendInterval = useRef(null);
  const [isCameraOn, setIsCameraOn] = useState(true);
  const [isMicOn, setIsMicOn] = useState(true);
  const hasCamera = useRef();
  const hasMicrophone = useRef();
  let dummyTrack = null;
  let dummyLocalTrack = null;
  let dummyTransparentTrack = null;
  const moreOptionsRef = useRef(null);
  const moreOptionsButtonRef = useRef(null);

  // New state variables for reactions
  const [showReactions, setShowReactions] = useState(false);
  const [reactions, setReactions] = useState([]);
  const reactionsPanelRef = useRef(null);
  const reactionsButtonRef = useRef(null);

  //Initialize local Media
  useEffect(() => {
    dummyLocalTrack = createLocalDummyVideoTrack();
    dummyTrack = createDummyVideoTrack();
    dummyTransparentTrack = createTransparentDummyVideoTrack();
    startB();

    // Check if device is mobile
    const checkMobileDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // Regular expression to check for mobile devices
      const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
      setIsMobileDevice(isMobile);
    };

    checkMobileDevice();

    return () => {
      if (localStream) {
        localStream.getTracks().forEach((track) => track.stop());
        localStream = null;
      }
      if (remoteVideoDummy.current) {
        const tracks = remoteVideoDummy.current.getTracks();
        tracks.forEach((track) => track.stop());
        remoteVideoDummy.current = null;
      }
      if (dummyTrack) {
        try {
          dummyTrack.stop();
        } catch (e) {
          console.log(e);
        }
      }
      if (dummyLocalTrack) {
        try {
          dummyLocalTrack.stop();
        } catch (e) {
          console.log(e);
        }
      }
      if (dummyTransparentTrack) {
        try {
          dummyTransparentTrack.stop();
        } catch (e) {
          console.log(e);
        }
      }
      setisJoined(false);
      stopRecording();
      socket.emit("exitRoom");
      hangup();
    };
  }, []);

  useEffect(() => {
    if (searching && remoteVideoDummy && remoteVideoDummy.current) {
      remoteVideo.current.srcObject = remoteVideoDummy.current;
    }
  }, [searching]);

  //Socket listeners
  useEffect(() => {
    const handleRoomClosed = () => {
      setroomId("");

      hangup();
      setisJoined(false);
    };
    const handlePaired = (data) => {
      setSearching(false);
      setroomId(data.roomId);
      setisJoined(true);
      audioSocket.emit("getStarters", {
        soulmateUsername: data.soulmateUsername,
        soulmateStatus: data.soulmateStatus,
      });
      setSoulmateUsername(data.soulmateUsername);
      setSoulmateStatus(data.soulmateStatus);
    };
    const handleVideoCallCommunication = (e) => {
      if (!localStream) {
        console.log("not ready yet");
        return;
      }
      switch (e.type) {
        case "offer":
          handleOffer(e);
          break;
        case "answer":
          handleAnswer(e);
          break;
        case "candidate":
          handleCandidate(e);
          break;
        case "ready":
          if (pc) {
            console.log(pc);
            console.log("already in call, ignoring");
            return;
          }
          makeCall();
          break;

        case "bye":
          if (pc) {
            console.log("try to hangup");
            hangup();
          }
          break;

        case "reaction":
          showReaction(e.emoji);
          break;

        case "screenShareStatus":
          // Set remote screen sharing status
          setRemoteScreenSharing(e.isScreenSharing);
          break;

        default:
          console.log("unhandled", e);
          break;
      }
    };
    socket.on("paired", handlePaired);
    socket.on("roomClosed", handleRoomClosed);
    socket.on("messageVideo", handleVideoCallCommunication);
    return () => {
      socket.off("paired", handlePaired);
      socket.off("roomClosed", handleRoomClosed);
      socket.off("messageVideo", handleVideoCallCommunication);
    };
  }, [socket]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Handle more options dropdown
      if (
        showMoreOptions &&
        moreOptionsRef.current &&
        !moreOptionsRef.current.contains(event.target) &&
        !moreOptionsButtonRef.current.contains(event.target) &&
        !filterPanelRef.current?.contains(event.target)
      ) {
        setShowMoreOptions(false);
        setShowBackgroundOptions(false);
        setShowVoiceOptions(false);
        setShowScreenOptions(false);
      }

      // Handle reactions panel separately
      if (
        showReactions &&
        reactionsPanelRef.current &&
        !reactionsPanelRef.current.contains(event.target) &&
        !reactionsButtonRef.current.contains(event.target)
      ) {
        setShowReactions(false);
      }
    };

    // Only add listener if either panel is open
    if (showMoreOptions || showReactions) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMoreOptions, showReactions]);

  async function handleClick() {
    if (searching) {
      // If already searching, cancel the search
      cancelSearch();
    } else {
      // Start the search process
      startSearch();
    }
  }

  async function startSearch() {
    setSearching(true);
    setSearchDuration(0);

    // Start a timer to track search duration
    if (searchTimer.current) {
      clearInterval(searchTimer.current);
    }
    searchTimer.current = setInterval(() => {
      setSearchDuration((prev) => prev + 1);
    }, 1000);

    socket.emit("exitRoom");
    if (isJoined) hangB();
    setisJoined(false);

    setroomId("");
    
    // Console logs to track demographic data
    console.log("[ConnectionComponent] Starting search with user data:");
    if (isLoggedIn) {
      console.log("[ConnectionComponent] Registered user:", {
        username: userData.username,
        age: userData.age,
        country: userData.country,
        interests: userData.interests?.length || 0
      });
    } else {
      console.log("[ConnectionComponent] Guest user:", {
        username: guestData.username,
        name: guestData.name,
        age: guestData.age,
        country: guestData.country,
        interests: guestData.interests?.length || 0
      });
    }

    socket.emit("join", {
      embeddings,
      username: isLoggedIn ? userData.username : guestData.username,
      isLoggedIn,
      interests: isLoggedIn ? userData.interests : guestData.interests,
      interestsTree: isLoggedIn ? userData.interestsTree : guestData.interestsTree,
      age: isLoggedIn ? userData.age : guestData.age,
      country: isLoggedIn ? userData.country : guestData.country,
      relationshipType: isLoggedIn ? userData.relationshipType : guestData.relationshipType
    });
  }

  async function cancelSearch() {
    setSearching(false);

    // Clear the search timer
    if (searchTimer.current) {
      clearInterval(searchTimer.current);
      searchTimer.current = null;
    }

    socket.emit("cancelSearch", {
      username: isLoggedIn ? userData.username : guestData.username,
    });

    // Reset the remote video to show the placeholder
    if (remoteVideo && remoteVideo.current) {
      remoteVideo.current.srcObject = null;
    }
  }

  // Clean up timer on unmount
  useEffect(() => {
    return () => {
      if (searchTimer.current) {
        clearInterval(searchTimer.current);
      }
    };
  }, []);

  async function makeCall() {
    console.log("making call");
    try {
      pc = new RTCPeerConnection(configuration);
      pc.onicecandidate = (e) => {
        const message = {
          type: "candidate",
          candidate: null,
        };
        if (e.candidate) {
          message.candidate = e.candidate.candidate;
          message.sdpMid = e.candidate.sdpMid;
          message.sdpMLineIndex = e.candidate.sdpMLineIndex;
        }
        socket.emit("messageVideo", message);
      };
      pc.ontrack = (e) => (remoteVideo.current.srcObject = e.streams[0]);

      localStream.getTracks().forEach((track) => {
        if (
          (track.kind === "video" && isCameraOn) ||
          (track.kind === "audio" && isMicOn)
        ) {
          pc.addTrack(track, localStream);
        }
      });
      const offer = await pc.createOffer();
      socket.emit("messageVideo", { type: "offer", sdp: offer.sdp });
      await pc.setLocalDescription(offer);
    } catch (e) {
      console.log(e);
    }
  }

  async function handleOffer(offer) {
    console.log("handling offer");
    if (pc) {
      console.error("existing peerconnection");
      return;
    }
    try {
      pc = new RTCPeerConnection(configuration);
      pc.onicecandidate = (e) => {
        const message = {
          type: "candidate",
          candidate: null,
        };
        if (e.candidate) {
          message.candidate = e.candidate.candidate;
          message.sdpMid = e.candidate.sdpMid;
          message.sdpMLineIndex = e.candidate.sdpMLineIndex;
        }
        socket.emit("messageVideo", message);
      };
      pc.ontrack = (e) => (remoteVideo.current.srcObject = e.streams[0]);

      localStream.getTracks().forEach((track) => {
        if (
          (track.kind === "video" && isCameraOn) ||
          (track.kind === "audio" && isMicOn)
        ) {
          pc.addTrack(track, localStream);
        }
      });
      await pc.setRemoteDescription(offer);

      const answer = await pc.createAnswer();
      socket.emit("messageVideo", { type: "answer", sdp: answer.sdp });
      await pc.setLocalDescription(answer);
    } catch (e) {
      console.log(e);
    }
  }

  async function handleAnswer(answer) {
    console.log("handling answer");
    if (!pc) {
      console.error("no peerconnection");
      return;
    }
    if (pc.signalingState !== "have-local-offer") {
      console.error(
        `Attempt to set remote answer in wrong state: ${pc.signalingState}`
      );
      return;
    }
    try {
      await pc.setRemoteDescription(answer);
    } catch (e) {
      console.log(e);
    }
  }

  async function handleCandidate(candidate) {
    try {
      if (!pc) {
        console.error("no peerconnection");
        return;
      }
      if (!candidate) {
        await pc.addIceCandidate(null);
      } else {
        await pc.addIceCandidate(candidate);
      }
    } catch (e) {
      console.log(e);
    }
  }
  async function hangup() {
    try {
      if (pc) {
        pc.close();

        pc = null;
        if (remoteVideo && remoteVideo.current && remoteVideo.current.srcObject)
          remoteVideo.current.srcObject = null;
      }
    } catch (e) {
      console.log("Error while Hangup: " + e);
    }
  }
  async function sendAudio() {
    if (audioChunks.current.length > 0) {
      const concatenatedBuffer = audioChunks.current.reduce((acc, buffer) => {
        const tmp = new Uint8Array(acc.byteLength + buffer.byteLength);
        tmp.set(new Uint8Array(acc), 0);
        tmp.set(new Uint8Array(buffer), acc.byteLength);
        return tmp.buffer;
      }, new ArrayBuffer(0));
      audioChunks.current = [];
      audioSocket.emit("intervalAudioMessage", {
        username: isLoggedIn ? userData.username : guestData.username,
        audio: concatenatedBuffer,
        isLoggedIn: isLoggedIn,
      });
    }
  }
  function startRecordingSession(stream) {
    try {
      audioContext.current = new (window.AudioContext ||
        window.webkitAudioContext)();
      audioInput.current = audioContext.current.createMediaStreamSource(stream);
      scriptProcessor.current = audioContext.current.createScriptProcessor(
        4096,
        1,
        1
      );

      scriptProcessor.current.onaudioprocess = (audioProcessingEvent) => {
        const inputBuffer = audioProcessingEvent.inputBuffer;
        const inputData = inputBuffer.getChannelData(0);
        const pcmData = new Int16Array(inputData.length);
        for (let i = 0; i < inputData.length; i++) {
          pcmData[i] = Math.max(-1, Math.min(1, inputData[i])) * 0x7fff;
        }
        audioChunks.current.push(pcmData.buffer);
      };

      audioInput.current.connect(scriptProcessor.current);
      scriptProcessor.current.connect(audioContext.current.destination);

      setIsRecording(true);

      // Send audio chunks every 3 seconds
      sendInterval.current = setInterval(sendAudio, 10000);
    } catch (error) {
      console.error("Error accessing microphone:", error);
    }
  }
  const stopRecording = () => {
    try {
      try {
        if (audioContext && audioContext.current) audioContext.current.close();
        if (scriptProcessor && scriptProcessor.current)
          scriptProcessor.current.disconnect();
        if (audioInput && audioInput.current) audioInput.current.disconnect();
      } catch (e) {
        console.log(e);
      }

      setIsRecording(false);
      if (sendInterval.current) {
        clearInterval(sendInterval.current);
        sendInterval.current = null;
      }
      sendAudio();
    } catch (e) {
      console.log(e);
    }
  };
  function startRecording(stream) {
    if (!isStrictMode) return;
    isStrictMode = false;
    startRecordingSession(stream);
  }
  const checkDevicePermissions = async (deviceKind) => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const hasDevice = devices.some((device) => device.kind === deviceKind);

      if (!hasDevice) return false;

      // Test getUserMedia call to check permissions
      const stream = await navigator.mediaDevices.getUserMedia({
        [deviceKind.replace("input", "")]: true,
      });
      stream.getTracks().forEach((track) => track.stop());
      return true;
    } catch (err) {
      console.warn(`No permission for ${deviceKind}:`, err);
      return false;
    }
  };
  function createLocalDummyVideoTrack() {
    const canvas = Object.assign(document.createElement("canvas"), {
      width: "60vh",
      height: "30vw",
    });
    const ctx = canvas.getContext("2d");

    const image = new Image();

    image.src = cameraOff;

    // We'll draw the image once it has loaded
    image.onload = () => {
      drawImage();
    };

    function drawImage() {
      // Clear the canvas with black background
      ctx.fillStyle = "#000000";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Calculate position to center the image
      const scale = Math.min(
        canvas.width / image.width,
        canvas.height / image.height
      );
      const x = canvas.width / 2 - (image.width / 2) * scale;
      const y = canvas.height / 2 - (image.height / 2) * scale;

      // Draw the image at the center of the canvas
      ctx.drawImage(image, x, y, image.width * scale, image.height * scale);
    }

    const stream = canvas.captureStream(1); // 1 fps is enough for a static image
    return stream.getVideoTracks()[0];
  }
  function createTransparentDummyVideoTrack() {
    const canvas = document.createElement("canvas");
    canvas.width = 320;
    canvas.height = 240;
    const ctx = canvas.getContext("2d");
    let rotation = 0;

    function draw() {
      // Clear the canvas
      ctx.fillStyle = "black";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }

    // Draw every 50ms (20 fps) for smoother animation while still being efficient
    setInterval(draw, 1000);

    const stream = canvas.captureStream(1); // Capture at 20 fps
    return stream.getVideoTracks()[0];
  }
  function createDummyVideoTrack() {
    const canvas = document.createElement("canvas");
    canvas.width = 320;
    canvas.height = 240;
    const ctx = canvas.getContext("2d");
    let rotation = 0;

    function draw() {
      // Clear the canvas
      ctx.fillStyle = "black";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Draw the rotating loading indicator
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const radius = 20; // Slightly larger radius

      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, rotation, rotation + Math.PI * 0.75);
      ctx.strokeStyle = "grey";
      ctx.lineWidth = 2; // Much thinner line
      ctx.stroke();

      // Update rotation
      rotation += Math.PI / 16; // Rotate by 11.25 degrees each frame for smoother animation
      if (rotation >= Math.PI * 2) {
        rotation = 0;
      }
    }

    // Draw every 50ms (20 fps) for smoother animation while still being efficient
    setInterval(draw, 50);

    const stream = canvas.captureStream(20); // Capture at 20 fps
    return stream.getVideoTracks()[0];
  }

  const startB = async () => {
    try {
      hasCamera.current = await checkDevicePermissions("videoinput");
      hasMicrophone.current = await checkDevicePermissions("audioinput");
      console.log("cameraStatus " + hasCamera.current);
      console.log("micStatus " + hasMicrophone.current);
      const constraints = {
        video: hasCamera.current,
        audio: hasMicrophone.current,
      };

      localStream = await navigator.mediaDevices.getUserMedia(constraints);

      // Dummy Video

      remoteVideoDummy.current = new MediaStream([dummyTrack]);
      remoteVideo.current.srcObject = null;
      //
      if (!hasCamera.current) localStream.addTrack(dummyTransparentTrack);
      if (localVideo.current) localVideo.current.srcObject = localStream;

      audioTrack = localStream.getAudioTracks()[0];

      setIsCameraOn(hasCamera.current);
      if (audioTrack) setIsMicOn(audioTrack.enabled);
      else setIsMicOn(false);
      if (audioTrack) {
        audioStream = new MediaStream([audioTrack]);
        startRecording(audioStream);
      }
    } catch (err) {
      console.error("Error accessing media devices:", err);
    }
  };

  const hangB = async () => {
    hangup();
    socket.emit("messageVideo", { type: "bye" });
  };
  const toggleCamera = () => {
    if (localStream) {
      const videoTrack = localStream.getVideoTracks()[0];
      if (!videoTrack || (hasCamera && !hasCamera.current)) return;
      if (videoTrack.label === "dummyVideoTrack") return;
      videoTrack.enabled = !videoTrack.enabled;
      setIsCameraOn(videoTrack.enabled);

      if (pc) {
        const videoSender = pc
          .getSenders()
          .find((sender) => sender.track && sender.track.kind === "video");
        if (videoSender) {
          videoSender.track.enabled = videoTrack.enabled;
        } else if (videoTrack.enabled) {
          pc.addTrack(videoTrack, localStream);
        }
      }
    }
  };

  const toggleMic = () => {
    if (localStream) {
      const currentAudioTrack = localStream.getAudioTracks()[0];
      if (!currentAudioTrack) return;
      currentAudioTrack.enabled = !currentAudioTrack.enabled;
      setIsMicOn(currentAudioTrack.enabled);

      if (pc) {
        const audioSender = pc
          .getSenders()
          .find((sender) => sender.track && sender.track.kind === "audio");
        if (audioSender) {
          audioSender.track.enabled = currentAudioTrack.enabled;
        } else if (currentAudioTrack.enabled) {
          pc.addTrack(currentAudioTrack, localStream);
        }
      }
    }
  };

  // New functions for additional features
  const toggleMoreOptions = () => {
    // Close all submenus when toggling the main menu
    if (showMoreOptions) {
      setShowBackgroundOptions(false);
      setShowVoiceOptions(false);
      setShowScreenOptions(false);
    }
    setShowMoreOptions(!showMoreOptions);
  };

  // Toggle background filter options
  const toggleBackgroundOptions = () => {
    setShowBackgroundOptions(!showBackgroundOptions);
    setShowVoiceOptions(false);
    setShowScreenOptions(false);
  };

  // Toggle voice changer options
  const toggleVoiceOptions = () => {
    setShowVoiceOptions(!showVoiceOptions);
    setShowBackgroundOptions(false);
    setShowScreenOptions(false);
  };

  // Toggle screen sharing options
  const toggleScreenOptions = () => {
    setShowScreenOptions(!showScreenOptions);
    setShowBackgroundOptions(false);
    setShowVoiceOptions(false);
  };

  // Voice changer function
  const changeVoice = (effect) => {
    setVoiceEffect(effect);

    if (localStream) {
      try {
        // Get the current audio track
        const currentAudioTrack = localStream.getAudioTracks()[0];
        if (!currentAudioTrack) return;

        // For the 'normal' option, restore the original audio
        if (effect === "normal") {
          // Stop any existing processed audio track
          if (audioTrack && audioTrack !== currentAudioTrack) {
            audioTrack.stop();
          }

          // Get a fresh audio stream
          navigator.mediaDevices
            .getUserMedia({ audio: true, video: false })
            .then((newStream) => {
              const newAudioTrack = newStream.getAudioTracks()[0];

              if (newAudioTrack) {
                // Remove current audio track
                localStream.removeTrack(currentAudioTrack);
                currentAudioTrack.stop();

                // Add new audio track
                localStream.addTrack(newAudioTrack);
                audioTrack = newAudioTrack;

                // Replace in peer connection if exists
                if (pc) {
                  const audioSender = pc
                    .getSenders()
                    .find(
                      (sender) => sender.track && sender.track.kind === "audio"
                    );
                  if (audioSender) {
                    audioSender.replaceTrack(newAudioTrack);
                  }
                }

                // Update audio recording stream
                if (audioTrack) {
                  audioStream = new MediaStream([audioTrack]);
                  // Restart audio recording for chat
                  stopRecording();
                  startRecording(audioStream);
                }
              }
            })
            .catch((err) => {
              console.error("Error restoring normal voice:", err);
            });

          return;
        }

        // Create an AudioContext for audio processing
        const audioCtx = new (window.AudioContext ||
          window.webkitAudioContext)();

        // Create a MediaStreamSource from the current audio track
        const sourceStream = new MediaStream([currentAudioTrack]);
        const source = audioCtx.createMediaStreamSource(sourceStream);

        // Create a destination to collect the processed audio
        const destination = audioCtx.createMediaStreamDestination();

        // Apply different effects based on selection
        let effectNode;

        if (effect === "deep") {
          // Deep voice effect (lowering pitch)
          effectNode = audioCtx.createBiquadFilter();
          effectNode.type = "lowshelf";
          effectNode.frequency.value = 500;
          effectNode.gain.value = 15;

          // Additional low pass filter for deep voice
          const lowPass = audioCtx.createBiquadFilter();
          lowPass.type = "lowpass";
          lowPass.frequency.value = 1000;

          // Connect the source to the filter and then to destination
          source.connect(effectNode);
          effectNode.connect(lowPass);
          lowPass.connect(destination);
        } else if (effect === "high") {
          // High voice effect (raising pitch)
          effectNode = audioCtx.createBiquadFilter();
          effectNode.type = "highshelf";
          effectNode.frequency.value = 1000;
          effectNode.gain.value = 15;

          // Additional high pass filter
          const highPass = audioCtx.createBiquadFilter();
          highPass.type = "highpass";
          highPass.frequency.value = 500;

          source.connect(effectNode);
          effectNode.connect(highPass);
          highPass.connect(destination);
        } else if (effect === "robot") {
          // Robot voice effect (modulation with oscillator)
          const oscillator = audioCtx.createOscillator();
          oscillator.type = "square";
          oscillator.frequency.value = 40;

          const gain = audioCtx.createGain();
          gain.gain.value = 0.15;

          // Distortion for robotic effect
          const distortion = audioCtx.createWaveShaper();
          function makeDistortionCurve(amount) {
            const k = amount;
            const n_samples = 44100;
            const curve = new Float32Array(n_samples);

            for (let i = 0; i < n_samples; ++i) {
              const x = (i * 2) / n_samples - 1;
              curve[i] =
                ((3 + k) * x * 20 * (Math.PI / 180)) /
                (Math.PI + k * Math.abs(x));
            }
            return curve;
          }

          distortion.curve = makeDistortionCurve(100);

          // Connect everything
          source.connect(distortion);
          distortion.connect(destination);

          oscillator.connect(gain);
          gain.connect(destination);

          // Start the oscillator
          oscillator.start();
        }

        // Get the processed audio track
        const processedAudioTrack = destination.stream.getAudioTracks()[0];

        if (processedAudioTrack) {
          // Store refs to audio context to clean up later
          if (audioContext.current) {
            try {
              audioContext.current.close();
            } catch (e) {
              console.log("Error closing previous audio context:", e);
            }
          }
          audioContext.current = audioCtx;

          // Stop current audio track
          currentAudioTrack.stop();

          // Replace in the local stream
          localStream.removeTrack(currentAudioTrack);
          localStream.addTrack(processedAudioTrack);
          audioTrack = processedAudioTrack;

          // Update the peer connection if it exists
          if (pc) {
            const audioSender = pc
              .getSenders()
              .find((sender) => sender.track && sender.track.kind === "audio");
            if (audioSender) {
              audioSender.replaceTrack(processedAudioTrack);
            }
          }

          // Update audio recording stream
          audioStream = new MediaStream([processedAudioTrack]);
          stopRecording();
          startRecording(audioStream);
        }
      } catch (error) {
        console.error("Error applying voice effect:", error);
        setVoiceEffect("normal");
      }
    }
  };

  // Screen sharing function
  const toggleScreenSharing = async () => {
    try {
      // Check if device is mobile
      if (isMobileDevice) {
        alert("Screen sharing is not available on mobile devices");
        return;
      }

      if (!isScreenSharing) {
        // Start screen sharing
        const screenStream = await navigator.mediaDevices.getDisplayMedia({
          video: {
            cursor: 'always' // Add cursor for better usability during screen sharing
          },
          audio: true,
        });

        // Save current video track to restore later
        const currentVideoTrack = localStream.getVideoTracks()[0];

        // Get the screen video track
        const screenVideoTrack = screenStream.getVideoTracks()[0];

        if (screenVideoTrack) {
          // Handle when user stops sharing via browser UI
          screenVideoTrack.onended = () => {
            toggleScreenSharing();
          };

          // Remove current video track
          if (currentVideoTrack) {
            localStream.removeTrack(currentVideoTrack);
          }

          // Add screen track to local stream
          localStream.addTrack(screenVideoTrack);

          // Update local video display
          if (localVideo.current) {
            localVideo.current.srcObject = localStream;
          }

          // Replace track in peer connection if it exists
          if (pc) {
            const videoSender = pc
              .getSenders()
              .find((sender) => sender.track && sender.track.kind === "video");
            if (videoSender) {
              videoSender.replaceTrack(screenVideoTrack);
            } else {
              pc.addTrack(screenVideoTrack, localStream);
            }
          }

          // Notify peer about screen sharing status
          socket.emit("messageVideo", {
            type: "screenShareStatus",
            isScreenSharing: true
          });

          setIsScreenSharing(true);
        }
      } else {
        // Stop screen sharing and restore camera
        const screenTrack = localStream.getVideoTracks()[0];
        if (screenTrack) {
          screenTrack.stop();
          localStream.removeTrack(screenTrack);
        }

        // Get camera video again
        const newStream = await navigator.mediaDevices.getUserMedia({
          video: hasCamera.current,
          audio: false,
        });

        const cameraTrack = newStream.getVideoTracks()[0];
        if (cameraTrack) {
          localStream.addTrack(cameraTrack);

          // Update local video display
          if (localVideo.current) {
            localVideo.current.srcObject = localStream;
          }

          // Replace track in peer connection if it exists
          if (pc) {
            const videoSender = pc
              .getSenders()
              .find((sender) => sender.track && sender.track.kind === "video");
            if (videoSender) {
              videoSender.replaceTrack(cameraTrack);
            } else {
              pc.addTrack(cameraTrack, localStream);
            }
          }
        }

        // Notify peer about screen sharing status
        socket.emit("messageVideo", {
          type: "screenShareStatus",
          isScreenSharing: false
        });

        setIsScreenSharing(false);
      }
    } catch (error) {
      console.error("Error toggling screen sharing:", error);
    }
  };

  // Screen recording functions
  const startScreenRecording = async () => {
    try {
      // Check if device is mobile
      if (isMobileDevice) {
        alert("Screen recording is not available on mobile devices");
        return;
      }

      // Request both screen and audio
      const screenStream = await navigator.mediaDevices.getDisplayMedia({
        video: { mediaSource: "screen" },
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          sampleRate: 44100,
        },
      });

      // Get microphone audio stream
      const micStream = await navigator.mediaDevices.getUserMedia({
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          sampleRate: 44100,
        },
      });

      // Combine all audio tracks with screen video
      const combinedStream = new MediaStream([
        ...screenStream.getVideoTracks(),
        ...screenStream.getAudioTracks(), // System audio
        ...micStream.getAudioTracks(), // Microphone audio
      ]);

      // Set up media recorder with combined stream
      const mediaRecorder = new MediaRecorder(combinedStream, {
        mimeType: "video/webm;codecs=vp9,opus",
      });
      mediaRecorderRef.current = mediaRecorder;
      recordedChunksRef.current = [];

      // Rest of your existing code...
      mediaRecorder.ondataavailable = (event) => {
        if (event.data && event.data.size > 0) {
          recordedChunksRef.current.push(event.data);
        }
      };

      mediaRecorder.onstop = () => {
        // Clean up all streams
        screenStream.getTracks().forEach((track) => track.stop());
        micStream.getTracks().forEach((track) => track.stop());

        // Create and download the recording
        const blob = new Blob(recordedChunksRef.current, {
          type: "video/webm",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";
        a.href = url;
        a.download = `screen-recording-${new Date().toISOString()}.webm`;
        a.click();
        window.URL.revokeObjectURL(url);
        recordedChunksRef.current = [];
        setIsRecordingScreen(false);

        // Remove the recording indicator
        const indicator = document.getElementById("recording-indicator");
        if (indicator) indicator.remove();
      };

      // Handle when user stops sharing via browser UI
      screenStream.getVideoTracks()[0].onended = () => {
        stopScreenRecording();
      };

      // Start recording
      mediaRecorder.start(1000);
      setIsRecordingScreen(true);

      // Display recording indicator
      const recordingIndicator = document.createElement("div");
      recordingIndicator.id = "recording-indicator";
      recordingIndicator.style.position = "fixed";
      recordingIndicator.style.top = "10px";
      recordingIndicator.style.right = "10px";
      recordingIndicator.style.backgroundColor = "rgba(255, 0, 0, 0.7)";
      recordingIndicator.style.color = "white";
      recordingIndicator.style.padding = "5px 10px";
      recordingIndicator.style.borderRadius = "5px";
      recordingIndicator.style.zIndex = "9999";
      recordingIndicator.textContent = "Recording Screen & Audio...";
      document.body.appendChild(recordingIndicator);
    } catch (error) {
      console.error("Error starting screen recording:", error);
    }
  };

  const stopScreenRecording = () => {
    if (mediaRecorderRef.current && isRecordingScreen) {
      mediaRecorderRef.current.stop();

      // Remove tracks
      if (mediaRecorderRef.current.stream) {
        mediaRecorderRef.current.stream
          .getTracks()
          .forEach((track) => track.stop());
      }

      // Remove recording indicator
      const indicator = document.getElementById("recording-indicator");
      if (indicator) {
        indicator.remove();
      }

      setIsRecordingScreen(false);
    }
  };

  const handleReactionClick = (emoji) => {
    // Send reaction to peer
    socket.emit("messageVideo", {
      type: "reaction",
      emoji,
    });

    // Show reaction locally
    showReaction(emoji);
    setShowReactions(false);
  };

  const showReaction = (emoji) => {
    const newReaction = {
      id: Date.now(),
      emoji,
      position: {
        x: Math.random() * 80 + 10, // Random position between 10% and 90%
        y: Math.random() * 40 + 30, // Random position between 30% and 70%
      },
    };

    setReactions((prev) => [...prev, newReaction]);

    // Remove reaction after animation
    setTimeout(() => {
      setReactions((prev) => prev.filter((r) => r.id !== newReaction.id));
    }, 1500);
  };

  return (
    <div className="ConnectionDetails">
      <div className={styles.videoContainer}>
        <video
          ref={localVideo}
          autoPlay
          playsInline
          muted
          className={`${buttonToggle ? styles.firstStream : styles.secondStream} ${isScreenSharing ? styles.noMirror : ''}`}
          onClick={() => {
            setButtonToggle(!buttonToggle);
          }}
        />
        <video
          ref={remoteVideo}
          autoPlay
          playsInline
          className={`${buttonToggle ? styles.secondStream : styles.firstStream} ${remoteScreenSharing ? styles.noMirror : ''}`}
          onClick={() => {
            setButtonToggle(!buttonToggle);
          }}
        />
        {reactions.map((reaction) => (
          <div
            key={reaction.id}
            className={styles.videoReaction}
            style={{
              left: `${reaction.position.x}%`,
              bottom: `${reaction.position.y}%`,
            }}
          >
            {reaction.emoji}
          </div>
        ))}
      </div>
      <div className={styles.connectionStatus}>
        <div className={styles.controlButtonsContainer}>
          <div
            className="center-flexbox"
          // style={{ display: isJoined ? "none" : "" }}
          >
            <button
              disabled={buttonToggle ? false : true}
              onClick={handleClick}
              className={`${styles.buttonNormal} ${searching ? styles.cancelSearchButton : ""
                }`}
            >
              {searching ? (
                <>
                  Cancel Searching
                </>
              ) : (
                "Search Soulmate"
              )}
            </button>
          </div>
          <div className={styles.controlButtons}>
            <button onClick={toggleCamera} className={styles.iconButton}>
              {isCameraOn ? (
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 44 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="44" height="44" rx="22" fill="#E2E2E2" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23.2 15.3999H16C15.2044 15.3999 14.4413 15.716 13.8787 16.2786C13.3161 16.8412 13 17.6043 13 18.3999V24.3999C13 25.1956 13.3161 25.9586 13.8787 26.5212C14.4413 27.0838 15.2044 27.3999 16 27.3999H23.2C23.9957 27.3999 24.7587 27.0838 25.3213 26.5212C25.8839 25.9586 26.2 25.1956 26.2 24.3999V18.3999C26.2 17.6043 25.8839 16.8412 25.3213 16.2786C24.7587 15.716 23.9957 15.3999 23.2 15.3999ZM14.2 18.3999C14.2 17.9225 14.3896 17.4647 14.7272 17.1271C15.0648 16.7895 15.5226 16.5999 16 16.5999H23.2C23.6774 16.5999 24.1352 16.7895 24.4728 17.1271C24.8104 17.4647 25 17.9225 25 18.3999V24.3999C25 24.8773 24.8104 25.3351 24.4728 25.6727C24.1352 26.0103 23.6774 26.1999 23.2 26.1999H16C15.5226 26.1999 15.0648 26.0103 14.7272 25.6727C14.3896 25.3351 14.2 24.8773 14.2 24.3999V18.3999Z"
                    fill="black"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M28.8735 16.696L25.2999 19.0204C25.2169 19.0742 25.1485 19.1477 25.1007 19.2344C25.053 19.3211 25.0274 19.4182 25.0263 19.5172L24.9939 22.6516C24.9927 22.7526 25.017 22.8524 25.0647 22.9415C25.1123 23.0307 25.1817 23.1064 25.2663 23.1616L28.8711 25.504C28.9617 25.563 29.0665 25.5964 29.1745 25.6008C29.2825 25.6052 29.3896 25.5803 29.4847 25.5288C29.5797 25.4773 29.659 25.4011 29.7143 25.3082C29.7696 25.2153 29.7988 25.1092 29.7987 25.0012V17.2C29.799 17.0918 29.77 16.9855 29.7148 16.8925C29.6596 16.7995 29.5803 16.7231 29.4852 16.6714C29.3901 16.6198 29.2829 16.5948 29.1748 16.5991C29.0667 16.6034 28.9618 16.6369 28.8711 16.696M28.5999 23.896L26.1987 22.3348L26.2239 19.8508L28.5999 18.3064V23.896Z"
                    fill="black"
                  />
                </svg>
              ) : (
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 44 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="44" height="44" rx="22" fill="#FFC6C6" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23.2 15.3999H16C15.2044 15.3999 14.4413 15.716 13.8787 16.2786C13.3161 16.8412 13 17.6043 13 18.3999V24.3999C13 25.1956 13.3161 25.9586 13.8787 26.5212C14.4413 27.0838 15.2044 27.3999 16 27.3999H23.2C23.9957 27.3999 24.7587 27.0838 25.3213 26.5212C25.8839 25.9586 26.2 25.1956 26.2 24.3999V18.3999C26.2 17.6043 25.8839 16.8412 25.3213 16.2786C24.7587 15.716 23.9957 15.3999 23.2 15.3999ZM14.2 18.3999C14.2 17.9225 14.3896 17.4647 14.7272 17.1271C15.0648 16.7895 15.5226 16.5999 16 16.5999H23.2C23.6774 16.5999 24.1352 16.7895 24.4728 17.1271C24.8104 17.4647 25 17.9225 25 18.3999V24.3999C25 24.8773 24.8104 25.3351 24.4728 25.6727C24.1352 26.0103 23.6774 26.1999 23.2 26.1999H16C15.5226 26.1999 15.0648 26.0103 14.7272 25.6727C14.3896 25.3351 14.2 24.8773 14.2 24.3999V18.3999Z"
                    fill="black"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M28.8738 16.696L25.3002 19.0204C25.2171 19.0742 25.1487 19.1477 25.101 19.2344C25.0532 19.3211 25.0277 19.4182 25.0266 19.5172L24.9942 22.6516C24.993 22.7526 25.0173 22.8524 25.0649 22.9415C25.1125 23.0307 25.1819 23.1064 25.2666 23.1616L28.8714 25.504C28.9619 25.563 29.0667 25.5964 29.1747 25.6008C29.2827 25.6052 29.3899 25.5803 29.4849 25.5288C29.5799 25.4773 29.6593 25.4011 29.7146 25.3082C29.7698 25.2153 29.799 25.1092 29.799 25.0012V17.2C29.7992 17.0918 29.7702 16.9855 29.715 16.8925C29.6598 16.7995 29.5805 16.7231 29.4854 16.6714C29.3904 16.6198 29.2831 16.5948 29.175 16.5991C29.0669 16.6034 28.962 16.6369 28.8714 16.696M28.6002 23.896L26.199 22.3348L26.2242 19.8508L28.6002 18.3064V23.896Z"
                    fill="black"
                  />
                  <path
                    d="M11.3802 12.2537C11.2645 12.1379 11.1996 11.9808 11.1997 11.8171C11.1998 11.6534 11.265 11.4964 11.3808 11.3807C11.4967 11.265 11.6537 11.2001 11.8174 11.2002C11.9812 11.2003 12.1381 11.2655 12.2538 11.3813L32.619 31.7465C32.7347 31.8622 32.7997 32.0191 32.7997 32.1827C32.7997 32.3463 32.7347 32.5032 32.619 32.6189C32.5033 32.7346 32.3464 32.7996 32.1828 32.7996C32.0192 32.7996 31.8623 32.7346 31.7466 32.6189L11.3802 12.2537Z"
                    fill="black"
                  />
                </svg>
              )}
            </button>
            <button onClick={toggleMic} className={styles.iconButton}>
              {isMicOn ? (
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 44 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="44" height="44" rx="22" fill="#E2E2E2" />
                  <path
                    d="M22 11.7144C20.977 11.7144 19.9959 12.1207 19.2726 12.8441C18.5492 13.5674 18.1428 14.5485 18.1428 15.5715V22.4286C18.1428 22.9352 18.2426 23.4367 18.4364 23.9047C18.6303 24.3727 18.9144 24.7979 19.2726 25.1561C19.6307 25.5142 20.0559 25.7983 20.5239 25.9922C20.9919 26.186 21.4934 26.2858 22 26.2858C22.5065 26.2858 23.0081 26.186 23.476 25.9922C23.944 25.7983 24.3692 25.5142 24.7274 25.1561C25.0855 24.7979 25.3697 24.3727 25.5635 23.9047C25.7573 23.4367 25.8571 22.9352 25.8571 22.4286V15.5715C25.8571 14.5485 25.4507 13.5674 24.7274 12.8441C24.004 12.1207 23.0229 11.7144 22 11.7144ZM19.4285 15.5715C19.4285 15.2338 19.495 14.8994 19.6243 14.5875C19.7535 14.2755 19.9429 13.992 20.1817 13.7532C20.4205 13.5144 20.7039 13.325 21.0159 13.1958C21.3279 13.0666 21.6623 13 22 13C22.3376 13 22.672 13.0666 22.984 13.1958C23.296 13.325 23.5795 13.5144 23.8182 13.7532C24.057 13.992 24.2464 14.2755 24.3757 14.5875C24.5049 14.8994 24.5714 15.2338 24.5714 15.5715V22.4286C24.5714 22.7663 24.5049 23.1007 24.3757 23.4127C24.2464 23.7247 24.057 24.0081 23.8182 24.2469C23.5795 24.4857 23.296 24.6751 22.984 24.8043C22.672 24.9336 22.3376 25.0001 22 25.0001C21.6623 25.0001 21.3279 24.9336 21.0159 24.8043C20.7039 24.6751 20.4205 24.4857 20.1817 24.2469C19.9429 24.0081 19.7535 23.7247 19.6243 23.4127C19.495 23.1007 19.4285 22.7663 19.4285 22.4286V15.5715ZM16.4285 21.7858C16.4285 21.6153 16.3608 21.4518 16.2402 21.3312C16.1197 21.2107 15.9562 21.1429 15.7857 21.1429C15.6152 21.1429 15.4517 21.2107 15.3311 21.3312C15.2106 21.4518 15.1428 21.6153 15.1428 21.7858V22.4286C15.1428 24.136 15.7797 25.782 16.929 27.0446C18.0783 28.3073 19.6573 29.0957 21.3571 29.2558V31.6429C21.3571 31.8134 21.4248 31.9769 21.5454 32.0975C21.666 32.2181 21.8295 32.2858 22 32.2858C22.1705 32.2858 22.334 32.2181 22.4545 32.0975C22.5751 31.9769 22.6428 31.8134 22.6428 31.6429V29.2558C24.3427 29.0957 25.9217 28.3073 27.071 27.0446C28.2202 25.782 28.8572 24.136 28.8571 22.4286V21.7858C28.8571 21.6153 28.7894 21.4518 28.6688 21.3312C28.5483 21.2107 28.3847 21.1429 28.2143 21.1429C28.0438 21.1429 27.8802 21.2107 27.7597 21.3312C27.6391 21.4518 27.5714 21.6153 27.5714 21.7858V22.4286C27.5714 23.5015 26.9844 24.5516 25.9396 25.3682C24.8947 26.3538 23.4776 26.9409 22 27.0001C20.5223 27.0001 19.1052 26.4131 18.0604 25.3682C17.0155 24.3234 16.4285 22.9063 16.4285 21.4286V20.7858Z"
                    fill="black"
                  />
                </svg>
              ) : (
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 44 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="44" height="44" rx="22" fill="#FFC6C6" />
                  <path
                    d="M18.1428 19.0514L11.9028 12.8114C11.8397 12.7526 11.789 12.6816 11.7539 12.6027C11.7188 12.5239 11.6999 12.4388 11.6983 12.3524C11.6968 12.2661 11.7127 12.1804 11.745 12.1003C11.7774 12.0203 11.8255 11.9476 11.8865 11.8865C11.9476 11.8255 12.0203 11.7774 12.1003 11.745C12.1804 11.7127 12.2661 11.6968 12.3524 11.6983C12.4388 11.6999 12.5239 11.7188 12.6027 11.7539C12.6816 11.789 12.7526 11.8397 12.8114 11.9028L32.0971 31.1886C32.2107 31.3104 32.2725 31.4716 32.2696 31.6382C32.2666 31.8047 32.1992 31.9636 32.0814 32.0814C31.9636 32.1992 31.8047 32.2666 31.6382 32.2696C31.4716 32.2725 31.3104 32.2107 31.1886 32.0971L26.6029 27.5114C25.5067 28.5066 24.117 29.1187 22.6428 29.2557V31.6429C22.6428 31.8133 22.5751 31.9769 22.4546 32.0974C22.334 32.218 22.1705 32.2857 22 32.2857C21.8295 32.2857 21.666 32.218 21.5454 32.0974C21.4249 31.9769 21.3571 31.8133 21.3571 31.6429V29.2557C19.6573 29.0956 18.0783 28.3072 16.929 27.0445C15.7797 25.7819 15.1428 24.1359 15.1428 22.4286V21.7857C15.1428 21.6152 15.2106 21.4517 15.3311 21.3311C15.4517 21.2106 15.6152 21.1428 15.7857 21.1428C15.9562 21.1428 16.1197 21.2106 16.2403 21.3311C16.3608 21.4517 16.4286 21.6152 16.4286 21.7857V22.4286C16.4286 23.5015 16.7384 24.5516 17.3209 25.4527C17.9033 26.3538 18.7335 27.0676 19.7118 27.5082C20.69 27.9489 21.7747 28.0977 22.8355 27.9368C23.8963 27.7759 24.8881 27.3121 25.6917 26.6011L24.4771 25.3857C23.9145 25.8571 23.229 26.1582 22.5012 26.2536C21.7734 26.349 21.0335 26.2347 20.3683 25.9242C19.7032 25.6137 19.1405 25.1198 18.7463 24.5006C18.3521 23.8814 18.1427 23.1626 18.1428 22.4286V19.0514ZM23.5617 24.4711L19.4286 20.338V22.4286C19.4286 22.9081 19.5628 23.3781 19.8158 23.7854C20.0689 24.1927 20.4308 24.5211 20.8607 24.7336C21.2906 24.946 21.7714 25.034 22.2487 24.9876C22.7259 24.9413 23.1807 24.7624 23.5617 24.4711ZM18.1454 15.4188L19.4286 16.7011V15.5714C19.4286 15.2337 19.4951 14.8994 19.6243 14.5874C19.7535 14.2754 19.9429 13.9919 20.1817 13.7531C20.4205 13.5144 20.704 13.325 21.0159 13.1957C21.3279 13.0665 21.6623 13 22 13C22.3377 13 22.6721 13.0666 22.984 13.1957C23.296 13.325 23.5795 13.5144 23.8183 13.7531C24.057 13.992 24.2465 14.2754 24.3757 14.5874C24.5049 14.8994 24.5714 15.2337 24.5714 15.5714V21.844L25.8031 23.0757C25.8386 22.8654 25.8566 22.6497 25.8571 22.4286V15.5714C25.8604 14.5595 25.4658 13.5869 24.7586 12.8632C24.0513 12.1395 23.088 11.7228 22.0763 11.7027C21.0646 11.6827 20.0856 12.0611 19.3503 12.7562C18.6149 13.4514 18.1822 14.4076 18.1454 15.4188ZM27.1883 24.4617L28.1637 25.4363C28.6077 24.5277 28.8571 23.5077 28.8571 22.4277V21.7866C28.8571 21.6161 28.7894 21.4526 28.6688 21.332C28.5483 21.2114 28.3848 21.1437 28.2143 21.1437C28.0438 21.1437 27.8803 21.2114 27.7597 21.332C27.6392 21.4526 27.5714 21.6161 27.5714 21.7866V22.4286C27.5714 23.146 27.436 23.8317 27.1891 24.4617"
                    fill="black"
                  />
                </svg>
              )}
            </button>

            {/* More Options Button */}
            <button
              ref={moreOptionsButtonRef}
              onClick={toggleMoreOptions}
              className={styles.iconButton}
            >
              <svg
                width="44"
                height="44"
                viewBox="0 0 44 44"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="44" height="44" rx="22" fill="#E2E2E2" />
                <path
                  d="M22 23C22.5523 23 23 22.5523 23 22C23 21.4477 22.5523 21 22 21C21.4477 21 21 21.4477 21 22C21 22.5523 21.4477 23 22 23Z"
                  fill="black"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M30 23C30.5523 23 31 22.5523 31 22C31 21.4477 30.5523 21 30 21C29.4477 21 29 21.4477 29 22C29 22.5523 29.4477 23 30 23Z"
                  fill="black"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14 23C14.5523 23 15 22.5523 15 22C15 21.4477 14.5523 21 14 21C13.4477 21 13 21.4477 13 22C13 22.5523 13.4477 23 14 23Z"
                  fill="black"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            {/* More Options Dropdown */}
            {showMoreOptions && (
              <div ref={moreOptionsRef} className={styles.moreOptionsDropdown}>
                {/* Main feature buttons */}
                <div className={styles.moreOptionsButtons}>
                  <button
                    className={`${styles.optionButton} ${showBackgroundOptions ? styles.active : ""
                      }`}
                    onClick={toggleBackgroundOptions}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
                        fill="currentColor"
                      />
                      <path
                        d="M12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8Z"
                        fill="currentColor"
                      />
                    </svg>
                    Background
                  </button>

                  {/* <button
                    className={`${styles.optionButton} ${showVoiceOptions ? styles.active : ""
                      }`}
                    onClick={toggleVoiceOptions}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 14C13.66 14 15 12.66 15 11V5C15 3.34 13.66 2 12 2C10.34 2 9 3.34 9 5V11C9 12.66 10.34 14 12 14Z"
                        fill="currentColor"
                      />
                      <path
                        d="M17 11C17 13.76 14.76 16 12 16C9.24 16 7 13.76 7 11H5C5 14.53 7.61 17.43 11 17.92V21H13V17.92C16.39 17.43 19 14.53 19 11H17Z"
                        fill="currentColor"
                      />
                    </svg>
                    Voice
                  </button> */}

                  <button
                    className={`${styles.optionButton} ${showScreenOptions ? styles.active : ""
                      }`}
                    onClick={toggleScreenOptions}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 3H4C2.9 3 2 3.9 2 5V17C2 18.1 2.9 19 4 19H8V21H16V19H20C21.1 19 22 18.1 22 17V5C22 3.9 21.1 3 20 3ZM20 17H4V5H20V17Z"
                        fill="currentColor"
                      />
                    </svg>
                    Screen
                  </button>
                </div>

                {/* Voice Changer Options
                {showVoiceOptions && (
                  <div className={styles.optionPanel}>
                    <div className={styles.optionPanelHeader}>
                      <h3>Voice Effects</h3>
                      <button
                        className={styles.closeButton}
                        onClick={() => setShowVoiceOptions(false)}
                      >
                        ×
                      </button>
                    </div>
                    <div className={styles.optionPanelContent}>
                      <button
                        className={`${styles.filterOption} ${voiceEffect === "normal" ? styles.active : ""
                          }`}
                        onClick={() => changeVoice("normal")}
                      >
                        Normal
                      </button>
                      <button
                        className={`${styles.filterOption} ${voiceEffect === "deep" ? styles.active : ""
                          }`}
                        onClick={() => changeVoice("deep")}
                      >
                        Deep
                      </button>
                      <button
                        className={`${styles.filterOption} ${voiceEffect === "high" ? styles.active : ""
                          }`}
                        onClick={() => changeVoice("high")}
                      >
                        High
                      </button>
                      <button
                        className={`${styles.filterOption} ${voiceEffect === "robot" ? styles.active : ""
                          }`}
                        onClick={() => changeVoice("robot")}
                      >
                        Robot
                      </button>
                    </div>
                  </div>
                )} */}

                {/* Screen Options */}
                {showScreenOptions && (
                  <div className={styles.optionPanel}>
                    <div className={styles.optionPanelHeader}>
                      <h3>Screen Options</h3>
                      <button
                        className={styles.closeButton}
                        onClick={() => setShowScreenOptions(false)}
                      >
                        ×
                      </button>
                    </div>
                    <div className={styles.optionPanelContent}>
                      {isMobileDevice ? (
                        <div className={styles.mobileNotice}>
                          Screen sharing and recording features are only available on desktop devices.
                        </div>
                      ) : (
                        <>
                          <button
                            className={`${styles.filterOption} ${isScreenSharing ? styles.active : ""}`}
                            onClick={toggleScreenSharing}
                          >
                            {isScreenSharing ? "Stop Sharing" : "Share Screen"}
                          </button>
                          <button
                            className={`${styles.filterOption} ${isRecordingScreen ? styles.active : ""}`}
                            onClick={
                              isRecordingScreen
                                ? stopScreenRecording
                                : startScreenRecording
                            }
                          >
                            {isRecordingScreen ? "Stop Recording" : "Record Screen"}
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Background Filter Component - Always mounted, visibility controlled by prop */}
            <BackgroundFilter
              ref={filterPanelRef}
              localStream={localStream}
              localVideo={localVideo}
              pc={pc}
              isExpanded={showBackgroundOptions && showMoreOptions}
              onClose={() => setShowBackgroundOptions(false)}
            />

            {/* Reactions Button */}
            <button
              ref={reactionsButtonRef}
              onClick={() => setShowReactions(!showReactions)}
              className={styles.reactionButton}
              title="Send Reaction"
            >
              😊
            </button>

            {/* Reactions Panel */}
            {showReactions && (
              <div ref={reactionsPanelRef} className={styles.reactionPanel}>
                {["❤️", "👍", "👏", "🎉", "😊", "🤣", "😮", "🔥"].map(
                  (emoji) => (
                    <button
                      key={emoji}
                      onClick={() => handleReactionClick(emoji)}
                      className={styles.reactionEmoji}
                    >
                      {emoji}
                    </button>
                  )
                )}
              </div>
            )}
          </div>
        </div>
        {isJoined ? (
          <div className={styles.connectionStatusContainer}>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect y="0.5" width="16" height="16" rx="8" fill="#4CAF50" />
            </svg>
            <span className={styles.connectionStatusText}>Connected</span>
          </div>
        ) : (
          <div className={styles.connectionStatusContainer}>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect y="0.5" width="16" height="16" rx="8" fill="#FFC107" />
            </svg>
            <span className={styles.connectionStatusText}>Not Connected</span>
          </div>
        )}
      </div>
    </div>
  );
}